export default "__VITE_PUBLIC_ASSET__764a2c8f__"